import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, MessageCircle, Mail } from 'lucide-react';
import { Particles } from './Particles';
import { useLanguage } from '../i18n/LanguageContext';
export const Footer = () => {
  const {
    t
  } = useLanguage();
  return <footer className="relative bg-black py-20 overflow-hidden border-t border-white/5" data-id="element-56">
      <Particles data-id="element-57" />

      <div className="container mx-auto px-6 relative z-10 flex flex-col items-center text-center" data-id="element-58">
        <motion.div className="font-serif text-3xl md:text-4xl font-bold text-primary tracking-widest mb-4" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-59">
          ✦ SOY JOHA ✦
        </motion.div>

        <motion.p className="text-gray-400 mb-12 tracking-wide" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        duration: 0.8
      }} data-id="element-60">
          {t('footer.tagline')}
        </motion.p>

        <motion.div className="flex gap-8 mb-16" initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5,
        duration: 0.5
      }} data-id="element-61">
          {[{
          icon: Instagram,
          href: 'https://www.instagram.com/soy__joha?igsh=cWlwdGMwNmI4cDBx'
        }, {
          icon: MessageCircle,
          href: 'https://wa.me/5492236514357?utm_source=chatgpt.com'
        }, {
          icon: Mail,
          href: '#'
        }].map((social, i) => <a key={i} href={social.href} target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full border border-gray-800 flex items-center justify-center text-gray-400 hover:text-primary hover:border-primary hover:shadow-[0_0_15px_rgba(212,175,55,0.4)] transition-all duration-300" data-id="element-62">
              <social.icon size={20} data-id="element-63" />
            </a>)}
        </motion.div>

        <motion.p className="text-xl font-serif italic text-white mb-16" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.7,
        duration: 0.8
      }} data-id="element-64">
          {t('footer.quote')}
        </motion.p>

        <motion.div className="w-full border-t border-gray-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-600" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.9,
        duration: 0.8
      }} data-id="element-65">
          <p data-id="element-66">{t('footer.copyright')}</p>
          <p data-id="element-67">{t('footer.designedBy')}</p>
        </motion.div>
      </div>
    </footer>;
};